import type { Comic, Category, AboutData, Review } from './types';

export const categories: Category[] = [
  { id: 'romance', name: '恋爱甜宠', slug: 'romance', comicCount: 12580, description: '甜蜜浪漫的恋爱故事，让你感受心动的每一刻', keywords: ['恋爱', '甜宠', '浪漫', '校园', '都市'] },
  { id: 'fantasy', name: '玄幻奇幻', slug: 'fantasy', comicCount: 9870, description: '穿越异世界，开启奇幻冒险之旅', keywords: ['玄幻', '奇幻', '异世界', '冒险', '魔法'] },
  { id: 'action', name: '热血动作', slug: 'action', comicCount: 8560, description: '热血沸腾的战斗场面，点燃你的激情', keywords: ['热血', '动作', '战斗', '竞技', '体育'] },
  { id: 'thriller', name: '悬疑惊悚', slug: 'thriller', comicCount: 5420, description: '扣人心弦的悬疑故事，挑战你的推理能力', keywords: ['悬疑', '惊悚', '推理', '恐怖', '犯罪'] },
  { id: 'comedy', name: '搞笑日常', slug: 'comedy', comicCount: 7340, description: '轻松愉快的日常喜剧，带给你无限欢乐', keywords: ['搞笑', '日常', '喜剧', '治愈', '温馨'] },
  { id: 'drama', name: '剧情深度', slug: 'drama', comicCount: 6650, description: '引人深思的深度剧情，触动心灵的故事', keywords: ['剧情', '深度', '现实', '社会', '人性'] },
  { id: 'bl', name: 'BL专区', slug: 'bl', comicCount: 8910, description: '精选优质BL漫画作品，满足你的阅读需求', keywords: ['BL', '耽美', '纯爱', '男男', '彩虹'] },
  { id: 'gl', name: 'GL专区', slug: 'gl', comicCount: 4230, description: '精选优质GL漫画作品，细腻动人的情感描绘', keywords: ['GL', '百合', '女女', '纯爱', '彩虹'] },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '我的野蛮王妃',
    author: '朴秀晶',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%2C%20beautiful%20princess%20in%20elegant%20traditional%20hanbok%20dress%20with%20modern%20twist%2C%20soft%20pastel%20pink%20and%20cream%20background%2C%20romantic%20atmosphere%2C%20delicate%20lineart%2C%20anime%20inspired%20illustration%2C%20clean%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '一部跨越身份与阶级的浪漫爱情故事。普通女孩意外成为王妃候选人，在王宫中展开了一段既甜蜜又心酸的成长之旅。面对宫廷的明争暗斗，她能否守护自己的爱情？',
    rating: 4.8,
    views: 2350000,
    status: 'ongoing',
    rank: 1,
    isNew: false,
    isHot: true,
    updatedAt: '2026-07-08',
    chapters: Array.from({ length: 128 }, (_, i) => ({
      id: 1000 + i + 1,
      title: `第 ${i + 1} 话`,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 20))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
      number: i + 1,
    })),
  },
  {
    id: 2,
    title: '暗夜追踪者',
    author: '金志勋',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20thriller%20mystery%20comic%20cover%2C%20dark%20silhouette%20detective%20in%20rainy%20night%20city%20alley%2C%20dramatic%20lighting%20with%20neon%20reflections%2C%20noir%20atmosphere%2C%20suspenseful%20mood%2C%20clean%20illustration%20style&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '连环杀手在城市中肆虐，天才侦探与犯罪心理学家联手追凶。每一条线索都指向更深的黑暗，真相远比想象中更加残酷。这是一场智力与勇气的终极对决。',
    rating: 4.9,
    views: 1890000,
    status: 'ongoing',
    rank: 2,
    isNew: false,
    isHot: true,
    updatedAt: '2026-07-07',
    chapters: Array.from({ length: 96 }, (_, i) => ({
      id: 2000 + i + 1,
      title: `第 ${i + 1} 话`,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 20))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
      number: i + 1,
    })),
  },
  {
    id: 3,
    title: '异界剑圣传奇',
    author: '李东旭',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20action%20comic%20cover%2C%20sword%20master%20with%20flowing%20cape%20in%20magical%20ancient%20temple%2C%20glowing%20blue%20energy%20effects%2C%20epic%20heroic%20pose%2C%20warm%20golden%20light%20background%2C%20detailed%20character%20illustration&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '普通高中生意外穿越到剑与魔法的世界，凭借现代知识与不屈意志，一步步成为传说中的剑圣。在这个充满魔兽与魔法的异世界中，他将书写属于自己的传奇。',
    rating: 4.7,
    views: 2100000,
    status: 'ongoing',
    rank: 3,
    isNew: false,
    isHot: true,
    updatedAt: '2026-07-08',
    chapters: Array.from({ length: 145 }, (_, i) => ({
      id: 3000 + i + 1,
      title: `第 ${i + 1} 话`,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 25))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
      number: i + 1,
    })),
  },
  {
    id: 4,
    title: '甜蜜契约',
    author: '崔美妍',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20sweet%20romance%20comic%20cover%2C%20young%20couple%20holding%20hands%20in%20cherry%20blossom%20park%2C%20soft%20spring%20sunlight%2C%20pink%20petals%20falling%2C%20warm%20and%20gentle%20atmosphere%2C%20clean%20romantic%20illustration&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '为了偿还家族债务，她签下了一份特殊的契约婚姻。原以为只是一场交易，却在朝夕相处中渐生情愫。当契约到期，他们该如何面对这份意外的真心？',
    rating: 4.6,
    views: 1780000,
    status: 'completed',
    rank: 4,
    isNew: false,
    isHot: true,
    updatedAt: '2026-07-05',
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: 4000 + i + 1,
      title: `第 ${i + 1} 话`,
      updatedAt: `2026-${String(Math.max(1, 6 - Math.floor(i / 30))).padStart(2, '0')}-${String(Math.max(1, 25 - (i % 25))).padStart(2, '0')}`,
      number: i + 1,
    })),
  },
  {
    id: 5,
    title: '格斗之王',
    author: '姜泰浩',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fighting%20action%20comic%20cover%2C%20martial%20artist%20in%20dynamic%20fighting%20stance%20with%20flying%20sweat%20droplets%2C%20intense%20determined%20expression%2C%20dramatic%20arena%20lights%20background%2C%20powerful%20energy%2C%20clean%20bold%20illustration&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '地下格斗界的传奇人物重返擂台，为了找回失去的荣誉与尊严。每一场比赛都是生死较量，每一次出拳都蕴含着不屈的信念。真正的强者，从不认输。',
    rating: 4.5,
    views: 1560000,
    status: 'ongoing',
    rank: 5,
    isNew: false,
    isHot: false,
    updatedAt: '2026-07-06',
    chapters: Array.from({ length: 112 }, (_, i) => ({
      id: 5000 + i + 1,
      title: `第 ${i + 1} 话`,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 22))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
      number: i + 1,
    })),
  },
  {
    id: 6,
    title: '校园疯人院',
    author: '尹智恩',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comedy%20school%20life%20comic%20cover%2C%20group%20of%20funny%20animated%20students%20in%20classroom%2C%20exaggerated%20funny%20expressions%2C%20bright%20colorful%20background%2C%20playful%20chaotic%20scene%2C%20clean%20humorous%20illustration&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '一群奇葩学生和更奇葩的老师们组成的校园日常。这里有最搞笑的课堂闹剧、最离谱的校园传说、最温暖的朋友情谊。每一天都是新的笑料。',
    rating: 4.4,
    views: 1340000,
    status: 'ongoing',
    rank: 6,
    isNew: false,
    isHot: true,
    updatedAt: '2026-07-08',
    chapters: Array.from({ length: 78 }, (_, i) => ({
      id: 6000 + i + 1,
      title: `第 ${i + 1} 话`,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 20))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
      number: i + 1,
    })),
  },
  {
    id: 7,
    title: '重生之商业帝国',
    author: '郑民秀',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20business%20drama%20comic%20cover%2C%20confident%20businessman%20in%20luxury%20office%20with%20city%20skyline%20view%2C%20sophisticated%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20clean%20modern%20illustration%2C%20professional%20elegant%20style&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '事业失败的他意外重生回到二十年前，带着未来的记忆，他决心打造属于自己的商业帝国。从零开始，步步为营，这一次他不会再让任何人阻挡他的道路。',
    rating: 4.8,
    views: 1980000,
    status: 'ongoing',
    rank: 7,
    isNew: false,
    isHot: true,
    updatedAt: '2026-07-07',
    chapters: Array.from({ length: 102 }, (_, i) => ({
      id: 7000 + i + 1,
      title: `第 ${i + 1} 话`,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 20))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
      number: i + 1,
    })),
  },
  {
    id: 8,
    title: '花间秘密',
    author: '韩秀雅',
    category: 'bl',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20BL%20romance%20comic%20cover%2C%20two%20handsome%20young%20men%20in%20flower%20garden%20with%20soft%20tender%20gaze%2C%20dreamy%20pastel%20color%20palette%2C%20romantic%20atmosphere%2C%20delicate%20floral%20elements%2C%20clean%20elegant%20illustration&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '花艺师与杂志编辑之间悄然绽放的爱情。在花香弥漫的工作室里，两个人从陌生到熟悉，从朋友到恋人。每一朵花都见证着他们之间最温柔的告白。',
    rating: 4.7,
    views: 1450000,
    status: 'ongoing',
    rank: 8,
    isNew: true,
    isHot: true,
    updatedAt: '2026-07-08',
    chapters: Array.from({ length: 56 }, (_, i) => ({
      id: 8000 + i + 1,
      title: `第 ${i + 1} 话`,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
      number: i + 1,
    })),
  },
  {
    id: 9,
    title: '月光下的约定',
    author: '林智慧',
    category: 'gl',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20GL%20romance%20comic%20cover%2C%20two%20beautiful%20women%20under%20moonlight%20by%20the%20sea%2C%20soft%20silver%20moonlight%20reflection%20on%20water%2C%20dreamy%20romantic%20atmosphere%2C%20gentle%20tender%20emotion%2C%20clean%20elegant%20illustration&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '在海边小镇长大的两个女孩，从小一起看月亮，约定永远不分开。随着年岁增长，这份感情也在悄然变化。月光见证了一切，却无法替她们说出心底的秘密。',
    rating: 4.6,
    views: 1120000,
    status: 'ongoing',
    rank: 9,
    isNew: true,
    isHot: false,
    updatedAt: '2026-07-06',
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: 9000 + i + 1,
      title: `第 ${i + 1} 话`,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 18))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
      number: i + 1,
    })),
  },
  {
    id: 10,
    title: '魔法学院优等生',
    author: '朴俊昊',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20magic%20academy%20fantasy%20comic%20cover%2C%20young%20mage%20student%20casting%20spell%20in%20ancient%20library%2C%20magical%20glowing%20runes%20floating%20around%2C%20warm%20candlelight%20atmosphere%2C%20mysterious%20enchanting%20mood%2C%20detailed%20character%20illustration&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '出身平民的天才魔法少年考入王国最顶级的魔法学院。在这里，他不仅要掌握高深魔法，还要面对贵族同学的排挤与歧视。实力，是打破一切偏见的唯一武器。',
    rating: 4.5,
    views: 1670000,
    status: 'ongoing',
    rank: 10,
    isNew: true,
    isHot: false,
    updatedAt: '2026-07-07',
    chapters: Array.from({ length: 90 }, (_, i) => ({
      id: 10000 + i + 1,
      title: `第 ${i + 1} 话`,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 20))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
      number: i + 1,
    })),
  },
  {
    id: 11,
    title: '末日生存法则',
    author: '金泰亨',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20post%20apocalyptic%20survival%20comic%20cover%2C%20survivors%20in%20destroyed%20city%20with%20dramatic%20orange%20sunset%20sky%2C%20rugged%20determined%20characters%2C%20intense%20survival%20atmosphere%2C%20clean%20bold%20illustration%2C%20cinematic%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '不明病毒爆发后，世界陷入混乱。一群幸存者在这个崩塌的世界中艰难求生。资源匮乏、人性考验、未知威胁，每一步都是在刀尖上行走。活下去，就是最大的胜利。',
    rating: 4.9,
    views: 2210000,
    status: 'ongoing',
    rank: 11,
    isNew: true,
    isHot: true,
    updatedAt: '2026-07-08',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: 11000 + i + 1,
      title: `第 ${i + 1} 话`,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 18))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
      number: i + 1,
    })),
  },
  {
    id: 12,
    title: '总裁的替身新娘',
    author: '孙艺珍',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20rich%20CEO%20romance%20comic%20cover%2C%20elegant%20woman%20in%20wedding%20dress%20with%20luxury%20mansion%20background%2C%20sophisticated%20romantic%20atmosphere%2C%20soft%20champagne%20color%20tones%2C%20clean%20glamorous%20illustration%2C%20dramatic%20lighting&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '双胞胎妹妹逃婚后，她不得不代替妹妹嫁给冷酷总裁。原以为这是一场地狱般的婚姻，却在相处中发现总裁冰冷外表下隐藏的温柔。当真相揭晓，他们的婚姻还能继续吗？',
    rating: 4.7,
    views: 2030000,
    status: 'ongoing',
    rank: 12,
    isNew: true,
    isHot: false,
    updatedAt: '2026-07-07',
    chapters: Array.from({ length: 68 }, (_, i) => ({
      id: 12000 + i + 1,
      title: `第 ${i + 1} 话`,
      updatedAt: `2026-${String(Math.max(1, 7 - Math.floor(i / 18))).padStart(2, '0')}-${String(Math.max(1, 28 - (i % 28))).padStart(2, '0')}`,
      number: i + 1,
    })),
  },
];

export const aboutData: AboutData = {
  brandName: '韩漫网',
  brandIntro: '韩漫网是国内领先的韩国漫画免费阅读平台，致力于为广大漫画爱好者提供海量优质的韩漫资源。自2020年成立以来，我们始终秉持"让好漫画触手可及"的理念，持续引进和翻译最新、最热的韩国漫画作品。',
  mission: '让每一位漫画爱好者都能轻松享受高品质的韩漫阅读体验',
  vision: '成为全球最具影响力的韩漫阅读社区平台',
  stats: [
    { label: '作品总数', value: '50,000+', suffix: '部' },
    { label: '日活用户', value: '200万+', suffix: '人' },
    { label: '用户满意度', value: '98%', suffix: '' },
    { label: '合作作者', value: '3,000+', suffix: '位' },
    { label: '累计阅读', value: '100亿+', suffix: '次' },
    { label: '日均更新', value: '500+', suffix: '话' },
  ],
  contactEmail: 'hello@ryjfh.cn',
  contactPhone: '400-888-6666',
  address: '北京市朝阳区望京SOHO T3 12层',
};

export const reviews: Review[] = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20young%20asian%20person%2C%20simple%20clean%20background%2C%20friendly%20smile%2C%20warm%20soft%20lighting%2C%20circular%20crop%20suitable%20for%20profile%20picture&width=100&height=100&seq=avatar-review-01&orientation=squarish',
    rating: 5,
    title: '最喜欢的韩漫平台',
    content: '韩漫网的更新速度真的快！基本上韩国那边刚出，这边就能看到翻译版了。而且画质清晰，阅读体验很好，强烈推荐给所有喜欢韩漫的朋友！',
    role: '资深读者',
  },
  {
    id: 2,
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20cute%20girl%20avatar%20portrait%2C%20pink%20hair%2C%20big%20bright%20eyes%2C%20happy%20expression%2C%20simple%20pastel%20background%2C%20circular%20profile%20picture%20style&width=100&height=100&seq=avatar-review-02&orientation=squarish',
    rating: 5,
    title: '分类太全了',
    content: '作为一个什么都看的漫画党，这里的分类真的太全了！恋爱、悬疑、奇幻、BL、GL什么都有，而且推荐算法很准，总能找到我喜欢的新作品。',
    role: '活跃用户',
  },
  {
    id: 3,
    name: '夜读达人',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20male%20avatar%20portrait%2C%20dark%20hair%2C%20glasses%2C%20calm%20expression%2C%20minimalist%20clean%20background%2C%20circular%20profile%20picture%20suitable%20for%20social%20media&width=100&height=100&seq=avatar-review-03&orientation=squarish',
    rating: 5,
    title: '夜间模式太贴心了',
    content: '我习惯晚上躺床上看漫画，夜间模式的设计太贴心了，不刺眼。而且加载速度很快，翻页流畅，整体体验非常好。已经是第三年续费会员了！',
    role: '三年会员',
  },
  {
    id: 4,
    name: '追更狂魔',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20enthusiastic%20young%20person%20avatar%2C%20bright%20energetic%20expression%2C%20colorful%20casual%20style%2C%20clean%20white%20background%2C%20circular%20profile%20picture&width=100&height=100&seq=avatar-review-04&orientation=squarish',
    rating: 4,
    title: '收藏功能很实用',
    content: '同时追了好多部漫画，收藏功能帮我整理得明明白白。每次更新都有提醒，再也不用担心漏看了。希望移动端的体验能继续优化！',
    role: '重度用户',
  },
  {
    id: 5,
    name: '漫画推荐官',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20anime%20style%20female%20avatar%20with%20warm%20smile%2C%20long%20brown%20hair%2C%20kind%20eyes%2C%20soft%20pastel%20background%2C%20circular%20profile%20picture%20professional%20look&width=100&height=100&seq=avatar-review-05&orientation=squarish',
    rating: 5,
    title: '社区氛围很棒',
    content: '评论区的小伙伴们都很友善，经常一起讨论剧情。还在这里认识了好多同好，一起建了读书群。韩漫网不仅是阅读平台，更是一个温暖的社区。',
    role: '社区活跃用户',
  },
  {
    id: 6,
    name: '新入坑小白',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20anime%20style%20beginner%20avatar%20portrait%2C%20curious%20expression%2C%20simple%20cute%20design%2C%20clean%20light%20background%2C%20circular%20profile%20picture&width=100&height=100&seq=avatar-review-06&orientation=squarish',
    rating: 5,
    title: '新手引导很友好',
    content: '之前从来没看过韩漫，朋友推荐来的。新手指引做得很好，很快就知道怎么找自己喜欢的类型了。现在每天都要上来看更新，完全停不下来！',
    role: '新用户',
  },
];